import { render, staticRenderFns } from "./product.vue?vue&type=template&id=99e35e7e&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=99e35e7e&prod&lang=scss&scoped=true"
import style1 from "./product.vue?vue&type=style&index=1&id=99e35e7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e35e7e",
  null
  
)

export default component.exports